import { API_URL, LOCAL_FALLBACK_API_URL } from './apiBase';

/**
 * GET /api/page/:pageCode — сначала REACT_APP_API_URL, при сбое — localhost:5000
 * (туннель / прод-API с фронтом на localhost).
 */
export async function fetchPageWithFallback(pageCode) {
  const tryFetch = async (base) => {
    const res = await fetch(`${base}/api/page/${pageCode}`);
    const data = await res.json();
    return { ok: res.ok, data };
  };

  try {
    const r1 = await tryFetch(API_URL);
    if (r1.ok || (r1.data && r1.data.success)) return r1.data;
  } catch {
    /* fallback */
  }

  if (API_URL !== LOCAL_FALLBACK_API_URL) {
    try {
      const r2 = await tryFetch(LOCAL_FALLBACK_API_URL);
      return r2.data;
    } catch {
      /* ignore */
    }
  }

  return { success: false, error: 'Load failed' };
}

export { API_URL, LOCAL_FALLBACK_API_URL };
